export default __webpack_public_path__ + "static/meta-preview-002370e5260c8acc7b63fbb2e7ef31e7.jpg";